import React from "react";
import classNames from "classnames";

import "./InlineInfoBox.css";

/**
 * @param {object} args
 * @param {'info'|'danger'} args.type
 */
export function InlineInfoBox({ children, type = "info" }) {
  return (
    <div
      className={classNames("InlineInfoBox", {
        "InlineInfoBox--info": type === "info",
        "InlineInfoBox--danger": type === "danger",
      })}
    >
      {children}
    </div>
  );
}
